module.exports = __webpack_public_path__ + "static/media/devsmatrix.a362b79d.svg";